// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar_2JJW-","Logo":"Toolbar_Logo_1efBD","DesktopOnly":"Toolbar_DesktopOnly_WADUd"};